import { Alert, Button } from '@shared/components';

interface Props {
    invoiceNumber: string;
    onDismiss: () => void;
}

export function InvoiceSuccessNotice({ invoiceNumber, onDismiss }: Props) {
    return (
        <Alert variant="success" role="status">
            <div className="space-y-3">
                <p>Invoice {invoiceNumber} submitted.</p>
                <Button type="button" size="sm" variant="outline" onClick={onDismiss}>
                    Dismiss
                </Button>
            </div>
        </Alert>
    );
}
